import {encryptRequestBody} from '../crypto';

const API_BASE = '/prod-api';
const CLIENT_ID = 'e5cd7e4891bf95d1d19206ce24a7b32e';
const TOKEN_COOKIE = 'Authorization';
const COOKIE_PATH = '; path=/; SameSite=Lax';

export const sharedCookieScope = (hostname = window.location.hostname) =>
    hostname === 'hyxyak.cn' || hostname.endsWith('.hyxyak.cn') ? '; Domain=.hyxyak.cn; Secure' : '';

const getToken = () => {
    const prefix = TOKEN_COOKIE + '=';
    const item = document.cookie.split('; ').find(cookie => cookie.startsWith(prefix));
    return item ? decodeURIComponent(item.slice(prefix.length)) : '';
};

const setToken = token => {
    document.cookie = TOKEN_COOKIE + '=; Max-Age=0' + COOKIE_PATH;
    document.cookie = TOKEN_COOKIE + '=' + encodeURIComponent(token) + COOKIE_PATH + sharedCookieScope();
};

const clearToken = () => {
    document.cookie = TOKEN_COOKIE + '=; Max-Age=0' + COOKIE_PATH;
    if (sharedCookieScope()) {
        document.cookie = TOKEN_COOKIE + '=; Max-Age=0' + COOKIE_PATH + sharedCookieScope();
    }
};

async function request(path, {withToken = true, ...options} = {}) {
    const headers = {...options.headers, clientid: CLIENT_ID, 'content-language': 'zh_CN'};
    if (withToken && getToken()) {
        headers.Authorization = 'Bearer ' + getToken();
    }
    if (options.body) {
        headers['Content-Type'] = 'application/json';
    }

    const response = await fetch(API_BASE + path, {...options, headers});
    const json = await response.json().catch(() => { throw new Error('接口返回格式错误（' + response.status + '）'); });
    if (!response.ok || (json.code != null && Number(json.code) !== 200)) {
        throw new Error(json.msg || json.message || '请求失败（' + response.status + '）');
    }
    return json;
}


export default class Api {
    static async appList() {
        const response = await request('/system/application/selectList');
        return {
            ...response,
            rows: (response.data || []).filter(app => app.appUrl).map(app => ({
                type: app.appType === 'topic' ? '2' : app.appType === 'mobile' || app.appType === 'qrcode' ? '0' : '1',
                name: app.appName,
                url: app.appUrl,
                icon: app.appIcon,
                openType: app.appType === 'qrcode' ? 'qrcode' : 'link'
            }))
        };
    }

    static getCode() {
        return request('/auth/code', {withToken: false});
    }

    static async login(params) {
        const payload = {
            tenantId: '000000',
            clientId: CLIENT_ID,
            grantType: 'password',
            username: String(params?.username || '').trim(),
            password: String(params?.password || '')
        };
        if (params?.code) {
            payload.code = params.code;
        }
        if (params?.uuid) {
            payload.uuid = params.uuid;
        }

        const {body, encryptKey} = encryptRequestBody(payload);
        const response = await request('/auth/login', {
            method: 'POST',
            withToken: false,
            headers: {'encrypt-key': encryptKey},
            body
        });
        const token = response.data?.access_token || response.data?.accessToken;
        if (!token) {
            throw new Error('登录成功但未返回访问令牌');
        }
        setToken(token);
        return response;
    }

    static getInfo() {
        return request('/system/user/getInfo');
    }

    static async logout() {
        try {
            return await request('/auth/logout', {method: 'POST'});
        } finally {
            clearToken();
        }
    }
}
